import { ServerConfig } from "@/config/config";
import { ExtraButton, ExtraButtonLocation } from "@/models/extra-button";
import { Axios } from "./auth-service";

export class ExtraButtonServiceClass {
	private readonly url:string = `${ServerConfig.host}/admin/settings/extra-buttons`;
	private buttonsCache:ExtraButton[] = [];

	public async fetchButtons():Promise<ExtraButton[]>{
		let result = await Axios.get(`${this.url}`);
		this.buttonsCache = result.data.map((d:any)=>new ExtraButton(d));
		return this.buttonsCache;
	}

	public getButtons():ExtraButton[]{
		return this.buttonsCache;
	}

	public getButtonsByLocation(location:ExtraButtonLocation):ExtraButton[]{
		return this.buttonsCache.filter(b=>b.Location == location);
	}

	public async getButton(id:number):Promise<ExtraButton>{
		let result = await Axios.get(`${this.url}/${id}`);
		return new ExtraButton(result.data);
	}

	public async createButton(button:ExtraButton):Promise<ExtraButton>{
		let result = await Axios.post(`${this.url}`, button.getJSON());
		return new ExtraButton(result.data);
	}

	public async editButton(button:ExtraButton):Promise<ExtraButton>{
		let result = await Axios.put(`${this.url}/${button.ID}`, button.getJSON());
		return new ExtraButton(result.data);
	}

	public async deleteButton(button:ExtraButton):Promise<void>{
		await Axios.delete(`${this.url}/${button.ID}`);
	}

	public async init(){
		this.fetchButtons();
	}
}


export const ExtraButtonService = new ExtraButtonServiceClass();